// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// Contexts
import {FormContext} from '../../contexts/form-context';

// Styles
import './submit-button.scss';

function SubmitButton({className, label = 'go', onClick}) {
    const getClass = () =>
        classnames(
            {
                button: true,
                'submit-button': true,
            },
            className
        );

    const getProps = (formContext) => {
        const {isFormValid, onSubmit} = formContext;

        return {
            className: getClass(),
            disabled: !isFormValid(),
            onClick: (event) => handleClick(event, onSubmit),
            type: 'submit',
        };
    };

    const handleClick = (event, onSubmit) => {
        event && event.preventDefault && event.preventDefault();

        if (onClick) {
            onClick();
        }

        onSubmit(event);
    };

    return (
        <FormContext.Consumer>
            {(formContext) => <button {...getProps(formContext)}>{label}</button>}
        </FormContext.Consumer>
    );
}

SubmitButton.propTypes = {
    className: PropTypes.string,
    label: PropTypes.string,
    onClick: PropTypes.func,
};

export default SubmitButton;
